export type PermissionItem = {
  name: string;
  display_name: string;
  description?: string;
  granted: boolean;
  panel?: string;
  category?: string;
  keywords?: Record<string, string[]> | string[];
  display_data?: {
    last_in_category?: boolean;
    category?: string;
    next_category?: string;
  };
};

export type PermissionsByCategory = Record<string, PermissionItem[]>;

export type PanelPermissions = Record<string, PermissionsByCategory>;

export type SelectorOption = {
  id: string | number;
  value: string | number;
  label: string;
};

export interface UserPermissions {
  user_id: string | number;
  permissions: PanelPermissions;
  effective_permissions?: Record<string, Record<string, boolean>>;
  panel_display_names: Record<string, string>;
  implicitly_granted: boolean;
}

export interface GroupPermissions {
  group_id: string | number;
  permissions: PanelPermissions;
  panel_display_names: Record<string, string>;
  implicitly_granted: boolean;
}

export interface RolePermissions {
  role_id: string | number;
  permissions: PanelPermissions;
  panel_display_names: Record<string, string>;
  implicitly_granted: boolean;
}

export const flattenPermissions = (permissions: PanelPermissions) => {
  const flattened: Record<string, PermissionItem[]> = {};

  Object.entries(permissions || {}).forEach(([panelKey, categories]) => {
    const panelPermissions: PermissionItem[] = [];

    Object.values(categories || {}).forEach((permissionsList) => {
      panelPermissions.push(...permissionsList);
    });

    flattened[panelKey] = panelPermissions;
  });

  return flattened;
};
